import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import imgLogoDetranMt from '../../assets/images/logo-detran-mt.png';
import imgLogoPortalCredenciamento from '../../assets/images/logo-portal-de-credenciamento.png';
import imgLogoMtLogin from '../../assets/images/mt-login-logo.svg';
import backgroundLogin from '../../assets/images/background-login.jpg';
import { useAuth } from '../../hooks/useAuth';
import { Colors } from '../../themes/theme';
export var LoginPage = function () {
    var _a = useAuth(), login = _a.login, authenticated = _a.authenticated;
    var navigate = useNavigate();
    var handleLogin = function () {
        if (authenticated) {
            navigate('/');
            return;
        }
        login('mt-login');
    };
    var handleOtpLogin = function () {
        navigate('/login-otp');
    };
    return (_jsx(Box, { sx: {
            display: 'flex',
            height: '100vh',
            backgroundImage: "url(".concat(backgroundLogin, ")"),
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'center', md: 'unset' },
            justifyContent: { xs: 'center', md: 'unset' },
        }, children: _jsxs(Box, { sx: {
                width: { xs: '90%', sm: '70%', md: '35%' },
                minWidth: '320px',
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                backdropFilter: 'blur(10px)',
                padding: { xs: '1.5rem', md: '2rem' },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderRadius: { xs: '10px', md: '0px' },
            }, children: [_jsx(Box, { sx: {
                        marginTop: '2rem',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }, children: _jsx("img", { src: imgLogoDetranMt, alt: "Detran MT", style: { maxWidth: '100%' } }) }), _jsx(Box, { sx: {
                        marginBottom: { xs: '4rem', md: '0px' },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }, children: _jsx("img", { src: imgLogoPortalCredenciamento, alt: "Portal de Credenciamento", style: { maxWidth: '100%' } }) }), _jsxs(Stack, { spacing: 2, sx: {
                        width: '100%',
                        marginBottom: { xs: '0', md: '6rem' },
                    }, children: [_jsxs(Button, { onClick: handleLogin, variant: "contained", sx: {
                                backgroundColor: Colors.AZUL_GOV,
                                color: 'white',
                                paddingY: '0.8rem',
                                fontSize: '1rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }, children: ["Entrar com", _jsx("img", { src: imgLogoMtLogin, alt: "MT login", style: { marginLeft: '1rem' } })] }), _jsx(Button, { onClick: handleOtpLogin, variant: "text", sx: {
                                color: Colors.AZUL_GOV,
                                backgroundColor: 'white',
                                paddingY: '0.8rem',
                                fontSize: '1rem',
                                textTransform: 'uppercase',
                                fontWeight: 'bold',
                                textDecoration: 'underline',
                            }, children: "Logar com e-mail" })] })] }) }));
};
